import * as React from 'react';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { Newsletter } from '../../components/newsletter/Newsletter';
import { NewsletterProps } from '../../components/newsletter/Newsletter.props';
import { DefaultLayout } from '../../layout/default/DefaultLayout';

// noinspection JSUnusedGlobalSymbols
export default () => {
  // TODO: Add SEO props
  const seo = {
    description: '',
  };

  const newsletterProps: NewsletterProps = {
    collapsePadding: true,
    iFrameHeight: 1700,
    url: 'https://cloud.news.warnerbros.com.br/newsletter',
  };

  return (
    <DefaultLayout locale='pt-BR' seo={seo}>
      <HeadTitle title='Newsletter' />
      <Newsletter {...newsletterProps} />
    </DefaultLayout>
  );
};
